<template>
  <div class="container-fluid px-0" v-if="cash.suppliers[$route.params.id]">
    <content-store :storeDetail="cash.suppliers[$route.params.id]" />
    <div v-if="cash.suppliers[$route.params.id]?.template_type == 1">
      <damp-group :list="cash.products[$route.params.id]?.damp" />
      <ordination-template :list="cash.products[$route.params.id]?.ordinations" />
      <best-group :item="cash.products[$route.params.id]?.best" type="1" />
      <store-product :products="cash.products[$route.params.id]?.groups" />
    </div>
    <div v-else-if="cash.suppliers[$route.params.id]?.template_type == 2" class="mt-4">
      <best-group :item="cash.products[$route.params.id]?.best" type="2" />
      <special-temp
          :products="cash.products[$route.params.id]?.groups"
          :damp="cash.products[$route.params.id]?.damp"
      />
    </div>
</div>

</template>
<script setup>
import ContentStore from "./contentTemp.vue";
import StoreProduct from "./products.vue";
import OrdinationTemplate from "./ordinations.vue";
import DampGroup from "../Group/DampGroup.vue";
import BestGroup from "../Group/BestGroup.vue";
import SpecialTemp from "./SpecialTemp.vue";
import { useRoute } from "vue-router";
import { onMounted, onUnmounted } from "vue";
import { useCash } from "@/store/cash";
const cash = useCash();
const route = useRoute();
let productInterval;
onMounted(() => {
  cash.getDetail(route.params.id);
  cash.getProducts(route.params.id)
  productInterval = setInterval(()=>{cash.getProducts(route.params.id,'interval')}, 10000);
});
onUnmounted(() => {
  clearInterval(productInterval);
});
</script>